<template>
  <div class="web_index">
    <BaseHeader></BaseHeader>


    <div class="web_content">
      <div class="content_one">
        <img class="arrow_img" src="../../assets/png/arrow_left.png" style="margin-right: 10px">
        <div class="banner_box">
          <img class="content_img" src="../../assets/png/banner_20231122.png" >
        </div>

        <img class="arrow_img" src="../../assets/png/arrow_right.png" style="margin-left: 10px">
      </div>



      <div class="content_two">
        <span>产品矩阵</span>
      </div>

      <div class="content_array">
        <div class="array-line">
          <div class="piece" v-for="productItem in productList">
            <!--<img  src="../../assets/png/logo_ktx_mag.png" style="margin-left: 40px;margin-top: 80px;width:200px; height:auto;">-->
            <div class="icon">
              <img  :src="productItem.iconUrl" :style="'width:'+productItem.iconWidth+'px;height:auto'" >
            </div>
            <div class="name">{{productItem.title}}</div>
            <div class="detail">
              <router-link :to="{path: '/product',query:{id:productItem.id}}">
                <span style="cursor:pointer;"  type="text" size="small">详细介绍 >></span>
              </router-link>
              <!--<span style="cursor:pointer;" @click="detail(productItem.id)">详细介绍 >></span>-->
            </div>
          </div>

        </div>



      </div>
    </div>

    <component v-bind:is="'BaseBottom'"></component>

    <div style="position: fixed;right:50px;top:200px;">
      <router-link :to="{path: '/page',query:{id:3}}" style="display: inline-block;width: 164px;height: 156px;">
        <img src="../../assets/tmp/2023alert.jpg" style="display: inline-block;width: 164px;height: 156px;">
      </router-link>

    </div>

  </div>
</template>

<script>
  import router from '../../router'
  import BaseBottom from './BaseBottom.vue'
  import BaseHeader from './BaseHeader.vue'
  import productService from '../../service/ProductService'
export default {
    components: {BaseBottom: BaseBottom,BaseHeader},
  name: 'Index',
  data () {
    return {
        productList:[],
      jumpType:1
    }
  },
  methods: {
    jump(type){
      let that = this
      // that.jumpType = type
      if (type == 2){
        router.push({
          path: 'area',
          // query:{'jumpType':type}
        })
      } else if (type == 3){
        router.push({
          path: 'cooperate',
          // query:{'jumpType':type}
        })
      }  else if (type == 4){
        router.push({
          path: 'join',
          // query:{'jumpType':type}
        })
      } else if (type == 5){
        router.push({
          path: 'contact',
          // query:{'jumpType':type}
        })
      }
    },
    detail(columnType){
      router.push({
        path: 'about',
        query:{'columnType':columnType}
      })
    }
  },
  mounted :function() {
        let that=this
      productService.getListByIndex(this,{},function (resp) {
          that.productList=resp.productList
      })
  },
    updated(){

    }
}
</script>


<style scoped="page">
  .web_index{
    width: 100%;
    background-color: #F0F4F5;
  }
  .web_title{
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 1000;
  }
  .web_title_content{
    width: 1290px;
    height: 80px;
    margin: auto;
    position: relative;

  }
  .web_title_content a{text-decoration: none;color: #000000;}
  .title_img{
    margin-left: 40px;
    margin-top: 18px;
  }
  .title_content{
    height: 80px;
    position: absolute;
    right:45px;
    top: 0;
  }
  .title{
    float: right;
    height: 80px;
    line-height: 80px;
    font-size: 18px;
    margin-right: 50px;
  }
  .title_red{
    float: right;
    height: 70px;
    line-height: 80px;
    font-size: 18px;
    border-bottom: 2px solid #cd001b;
    color: #000000;
  }
  .title:first-child{margin-right: 0}

  .router-link-active {
    float: right;
    height: 70px;
    line-height: 80px;
    font-size: 18px;
    border-bottom: 2px solid #cd001b;
    color: #000000;
  }

  .web_content{
    width: 1290px;
    margin: auto;
    padding-top: 20px;
    padding-bottom: 60px;
    margin-top: 80px;
  }
  .content_one{
    height: 361px;
  }
  .banner_box{background-color: #cf9236;
  width: 1200px;
  height: 360px;
    display:inline-block;
    background-color: #F0F4F5;
    box-shadow: 0px 0px 10px #888888;
  }
  .content_img{
    /*width: 1200px;*/
    /*height: 361px;*/
    width: 1184px;
    height: 344px;

    /*margin:0 auto;*/
    margin: 8px;
  }
  .arrow_img{
    margin-bottom: 157px;
  }
  .content_two{
    padding-top: 25px;
    padding-bottom: 10px;
    margin-left: 40px;
    font-size: 20px;
    color: #000000;
  }
  .array-line{
    margin-left: 40px;
    width: 1200px;
    height: 280px;
    margin-top: 20px;
  }
  .array-line .piece{
    float: left;
    width: 280px;
    height: 280px;
    background-color: #ffffff;
    position: relative;
    margin-left: 26px;
    margin-bottom: 20px;
  }
  .array-line .piece:first-child{
    margin-left: 0;
  }

  .array-line .piece:nth-of-type(4n+1) {
    margin-left: 0;
  }

  .icon{
    width: 280px;
    height: 210px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }
  .name{
    width: 280px;
    text-align: center;
    font-size: 14px;
    color: #35495D;
    position: absolute;
    bottom: 56px;
  }
  .detail{
    width: 280px;
    text-align: center;
    font-size: 12px;
    color: #53A6DD;
    position: absolute;
    bottom:32px;
    text-decoration: none;
  }
  .detail a{text-decoration: none;color: #53A6DD;}


  .web_bottem{
    background-color: #2E3139;
    width: 100%;
    height: 120px;
    font-size: 16px;
    color:#939393;
    line-height: 120px;
    text-align: center;
    clear: both;
  }

  /*.product_href{}*/



</style>



// WEBPACK FOOTER //
// src/components/web/IndexV2.vue